<template>
            <span
            class="number"
            v-bind:class="`number-${number}`"/>
</template>

<script>
export default {
  name: 'KZNumber',
  props: {
    number: String,
  },
};
</script>

<style scoped>
.number {
  width: 64px;
  height: 92px;
  float: left;
  background: url('../../../assets/images/KZ/numbers.png') no-repeat;
  background-size: 100%;
}

.number-1 {
  background-position: 0 -95px;
}
.number-2 {
  background-position: 0 -189px;
}
.number-3 {
  background-position: 0 -282px;
}
.number-4 {
  background-position: 0 -377px;
}
.number-5 {
  background-position: 0 -471px;
}
.number-6 {
  background-position: 0 -565px;
}
.number-7 {
  background-position: 0 -660px;
}
.number-8 {
  background-position: 0 -753px;
}
.number-9 {
  background-position: 0 -848px;
}
.number-0 {
  background-position: 0 0;
}
</style>
